// extracted by mini-css-extract-plugin
export default {"editMsgContainer":"CreateCouponForm_editMsgContainer__PKbJi","editMsg":"CreateCouponForm_editMsg__NmeIf"};